import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useApiAccess } from "./useApiAccess";
import { getCategory } from "../../Service/CategoryService";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { queryKeys } from "./queryKeys";

export function useCategories() {
  const hasAccess = useApiAccess();
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const pathParams = { ...(productParam && { product: productParam }) };

  return useQuery(
    queryKeys.categories(productParam),
    () => getCategory(pathParams),
    { enabled: !!hasAccess }
  );
}
